export const ANALYTICS_EVENTS = {
  CALCULATION_READY: "calculation_ready",
  CALCULATION_SHARE_REQUESTED: "calculation_share_requested",
  CALCULATION_SHARE_CREATED: "calculation_share_created",
  CALCULATION_SHARE_FAILED: "calculation_share_failed",
  CALCULATION_LINK_COPIED: "calculation_link_copied",
  CALCULATION_NATIVE_SHARE_SUCCEEDED: "calculation_native_share_succeeded",
  CALCULATION_NATIVE_SHARE_FAILED: "calculation_native_share_failed",
  CALCULATION_ATTACH_REQUESTED: "calculation_attach_requested",
  CALCULATION_ATTACHED_TO_DEAL: "calculation_attached_to_deal",
  CALCULATION_ATTACH_FAILED: "calculation_attach_failed",
  SHARED_CALCULATION_OPENED: "shared_calculation_opened",
  SHARED_CALCULATION_CONTACT_CLICKED: "shared_calculation_contact_clicked",

  MARKET_OPENED: "market_opened",
  MARKET_LISTINGS_LOADED: "market_listings_loaded",
  MARKET_LISTINGS_LOAD_FAILED: "market_listings_load_failed",
  MARKET_SEARCH_APPLIED: "market_search_applied",
  MARKET_FILTER_APPLIED: "market_filter_applied",
  MARKET_LISTING_OPENED: "market_listing_opened",
  MARKET_LISTING_VIEWED: "market_listing_viewed",
  MARKET_FAVORITE_ADDED: "market_favorite_added",
  MARKET_FAVORITE_REMOVED: "market_favorite_removed",
  MARKET_LISTING_CREATE_STARTED: "market_listing_create_started",
  MARKET_LISTING_CREATED: "market_listing_created",
  MARKET_LISTING_UPDATED: "market_listing_updated",
  MARKET_LISTING_SAVE_FAILED: "market_listing_save_failed",
  MARKET_LISTING_CREATE_FAILED: "market_listing_create_failed",
  MARKET_LISTING_PUBLISH_TOGGLED: "market_listing_publish_toggled",
  MARKET_LISTING_SHARED: "market_listing_shared",
  MARKET_LISTING_SHARE_FAILED: "market_listing_share_failed",
  MARKET_SHARED_LISTING_OPENED: "market_shared_listing_opened",
  MARKET_CONTACT_CLICKED: "market_contact_clicked",

  FEATURE_ACCESS_DENIED: "feature_access_denied",
  PAYMENT_OPENED: "payment_opened",
  SUBSCRIPTION_PLAN_SELECTED: "subscription_plan_selected",
  PAYMENT_STARTED: "payment_started",

  AUTH_SIGN_IN_SUCCEEDED: "auth_sign_in_succeeded",
  AUTH_SIGN_UP_SUCCEEDED: "auth_sign_up_succeeded",
  LANDING_PHONE_CLICKED: "landing_phone_clicked",
  LANDING_LEAD_SUBMITTED: "landing_lead_submitted",
  ASSIGNMENT_CREATED: "assignment_created",
  ASSIGNMENT_UPDATED: "assignment_updated",
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export const YANDEX_DIRECT_GOAL_EVENTS: readonly AnalyticsEventName[] = [
  ANALYTICS_EVENTS.CALCULATION_READY,
  ANALYTICS_EVENTS.CALCULATION_SHARE_REQUESTED,
  ANALYTICS_EVENTS.CALCULATION_SHARE_CREATED,
  ANALYTICS_EVENTS.CALCULATION_SHARE_FAILED,
  ANALYTICS_EVENTS.CALCULATION_LINK_COPIED,
  ANALYTICS_EVENTS.CALCULATION_NATIVE_SHARE_SUCCEEDED,
  ANALYTICS_EVENTS.CALCULATION_NATIVE_SHARE_FAILED,
  ANALYTICS_EVENTS.CALCULATION_ATTACH_REQUESTED,
  ANALYTICS_EVENTS.CALCULATION_ATTACHED_TO_DEAL,
  ANALYTICS_EVENTS.CALCULATION_ATTACH_FAILED,
  ANALYTICS_EVENTS.SHARED_CALCULATION_OPENED,
  ANALYTICS_EVENTS.SHARED_CALCULATION_CONTACT_CLICKED,

  ANALYTICS_EVENTS.MARKET_OPENED,
  ANALYTICS_EVENTS.MARKET_LISTING_VIEWED,
  ANALYTICS_EVENTS.MARKET_FAVORITE_ADDED,
  ANALYTICS_EVENTS.MARKET_LISTING_CREATED,
  ANALYTICS_EVENTS.MARKET_LISTING_SHARED,
  ANALYTICS_EVENTS.MARKET_SHARED_LISTING_OPENED,
  ANALYTICS_EVENTS.MARKET_CONTACT_CLICKED,
];

export const YANDEX_FALLBACK_GOAL = "product_event";

export type AnalyticsPrimitive = string | number | boolean | null;

export type AnalyticsProperties = Record<
  string,
  AnalyticsPrimitive | AnalyticsPrimitive[] | undefined
>;
